<h2 mat-dialog-title>{{ 'scim-administration.token.dialog.title' | translate }}</h2>

<mat-dialog-content>
	<p style="word-break: break-all; font-family: monospace; font-size: 14px; background-color: #f5f5f5; padding: 12px; border-radius: 4px; border: 1px solid rgba(0, 0, 0, 0.12); margin: 0">
		{{ token }}
	</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-flat-button color="primary" (click)="copyToClipboard()">
		{{ 'scim-administration.token.dialog.copy' | translate }}
	</button>
	<button mat-stroked-button (click)="onClose()" class="button-border-color">
		{{ 'scim-administration.token.dialog.close' | translate }}
	</button>
</mat-dialog-actions>
